<template>
  <div class="lidar-container" v-if="showTrailsPanel && panelVisible" id="trail_groups">
    <b-row class="w-100 blue-background tg-header" :class="!panelMinimized ? 'tg-header-border' : ''" no-gutters>
      <b-col class="col-sm-9 d-flex justify-content-start align-items-center flex-row pl-4">
        <span class="capitalize">Trail Groups</span>
      </b-col>
      <b-col class="col-sm-2 d-flex justify-content-center align-items-center">
        <fa
          id="minOrMaxLidarPanelElement"
          class="float-right clickable"
          :title="
            panelMinimized ? 'Maximize Lidar Panel' : 'Minimize Lidar Panel'
          "
          :icon="[
            'fas',
            panelMinimized ? 'window-maximize' : 'window-minimize'
          ]"
          @click="togglePanelHeight()"
        />
      </b-col>
    </b-row>
    <b-row v-if="!panelMinimized" no-gutters class="w-100 scrollable p-2 tg-body">
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column g-3" v-if="!trailsLoading && distinct_trails.length > 0">
        <b-row 
          v-for="(IDobj, index) in distinct_trails" 
          :key="IDobj.dateCode" 
          :id="'trail_' + IDobj.dateCode" 
          class="w-100" 
          :class="disableTrailGroups ? 'disable' : ''"
          no-gutters
        >
          <b-col class="col-sm-10 d-flex justify-content-center align-items-center">
            <b-button
              style="padding: 0px"
              class="btn py-1 lidar-label-size text-color"
              size="sm"
              @click="toggleTrailsGroup(IDobj, $event)"
              :class="anyPointcloudOfTrailGroupVisible(IDobj.dateCode)"
              variant="transparent"

            >
              {{ IDobj.dateCode }}
            </b-button>
          </b-col>
          <b-col class="col-sm-2 d-flex justify-content-start align-items-center text-color">
            <fa
              class="clickable"
              @click="expandTrailGroup(IDobj)"
              size="lg"
              :icon="['fas', IDobj.groupIsCollapsed ? 'caret-down' : 'caret-up']"
            />
          </b-col>
          <b-row v-if="!IDobj.groupIsCollapsed" id="pointCloudContainer" class="w-100 mt-1" no-gutters>
            <b-row
              v-for="pointcloudID in IDobj.pointcloudIDArr"
              :key="pointcloudID.pc_id"
              class="w-100 d-flex justify-content-center align-items-center mt-1 pl-1 text-color"
              no-gutters
            >
              <b-col class="col-sm-12 d-flex justify-content-center align-items-center">
                <b-button
                  size="sm"
                  class="btn w-100 text-truncate"
                  style="font-size: 0.8rem;"
                  variant="transparent"
                  :id="`pc-${pointcloudID.pc_id}`"
                  :class="availableTrailButtonCtrl(pointcloudID.pc_id)"
                  @click="toggleTrailLayer(pointcloudID, IDobj.dateCode)"
                  v-b-tooltip.hover
                  :title="pointcloudID.pc_id"
                >
                  {{ pointcloudID.pc_id }}
                </b-button>
              </b-col>
            </b-row>
          </b-row>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else-if="trailsLoading">
        <b-row no-gutters>
          <span class="d-flex justify-content-center my-4">
            <fa :icon="['fas', 'spinner']" size="3x" class="fa-spin tg-spinner"/>
          </span>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else-if="!lidarMinZoomAchieved">
        <b-row no-gutters class="d-flex justify-content-center align-items-center w-100 tg-warning" style="gap: 15px">
          <span class="d-flex justify-content-center">
            <fa :icon="['fas', 'exclamation-triangle']" size="2x"/>
          </span>
          <span class="d-flex justify-content-center">
            Zoom Level 15+
          </span>
        </b-row>
      </b-col>
      <b-col class="col-sm-12 m-0 p-0 d-flex justify-content-center align-items-center flex-column" v-else>
        <b-row no-gutters>
          <span class="d-flex justify-content-center mt-4">
            No available Lidar at current location
          </span>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
.disable {
  opacity: 0.6;
  pointer-events: none;
}

.lidar-container {
  width: 14.375rem;
  display: flex;
  flex-direction: column;
  max-height: calc(var(--vh, 1vh) * 100 - 10rem);
  /* min-height: 120px; */
  /* background: #ffffff; */
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(6, 60, 109, 0.12);
  color: #063c6d;
  overflow: hidden;
  font-family: system-ui, -apple-system, sans-serif;
}

.tg-header {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.5rem 0.75rem;
  background: #063c6d;
}

.tg-header-border {
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.tg-header span {
  color: #ffffff !important;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.tg-header .clickable {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.95rem;
}
.tg-header .clickable:hover {
  color: #ffffff !important;
}

.tg-body {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
  padding: 0.5rem;
  background-color: #eef3f9;
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
}

.tg-body::-webkit-scrollbar {
  width: 4px;
}
.tg-body::-webkit-scrollbar-track {
  background: transparent;
}
.tg-body::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.22);
  border-radius: 2px;
}
.tg-body::-webkit-scrollbar-button {
  display: none;
}

/* Trail group toggle button (date code) */
.lidar-label-size {
  width: 80%;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-radius: 6px;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

/* Group heading row */
.lidar-container .w-100.mt-1 {
  margin-top: 0.25rem !important;
}

/* Expand/collapse caret */
.lidar-container .clickable {
  color: rgba(6, 60, 109, 0.8);
  transition: color 0.15s ease;
}
.lidar-container .clickable:hover {
  color: #063c6d;
}

/* State messages (loading, zoom, empty) */
.lidar-container span {
  color: #063c6d;
  font-size: 0.82rem;
}

/* Loading spinner + zoom warning */
.tg-spinner {
  color: rgba(6, 60, 109, 0.5) !important;
}
.tg-warning {
  color: #b26a00;
}
.tg-warning span {
  color: #b26a00 !important;
  font-weight: 600;
}

/* ── Group button: all off ──────────────────────────── */
.lidar-group-off {
  color: #063c6d;
  background: #fff;
  border: 1px solid rgba(6, 60, 109, 0.2);
}

.lidar-group-off:hover {
  color: #063c6d;
  background: rgba(6, 60, 109, 0.06);
  border-color: rgba(6, 60, 109, 0.4);
}

/* ── Individual trail button: off ──────────────────── */
.lidar-off {
  color: #063c6d;
  background: #FFF;
  border: 1px solid rgba(6, 60, 109, 0.18);
}

.lidar-off:hover {
  color: #063c6d;
  background: rgba(6, 60, 109, 0.06);
  border-color: rgba(6, 60, 109, 0.35);
}

/* ── Active (btn-primary) — selected trail/group ── */
.lidar-container .btn-primary {
  color: #ffffff;
  background: #063c6d;
  border-color: #063c6d;
}

.lidar-container .btn-primary:hover {
  background: #0a4f8f;
  border-color: #0a4f8f;
}

/* ── Header background classes (keep for template compat) ── */
.blue-border-bottom {
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.blue-background {
  background: #063c6d;
  color: #ffffff !important;
  border-radius: 8px 8px 0 0;
}

.text-color {
  color: #063c6d;
}
</style>

<script>
export default {
  name: "Generic_LidarTiles",
  props: [
    'showLidarPanel',
    'lidarMinZoomAchieved',
    'showTrailsPanel',
    'distinct_trails',
    'trailsLoading',
    'map',
    'selectedExtent',
    'zoomLevel',
    'selectedTrails',
    'cart',
    'disableTrailGroups'
  ],
  data() {
    return {
      panelVisible: true,
      apiUrl: null,
      lidarGroup: null,
      currentIndex: 0,
      panelMinimized: false,
      selected: []
    }
  },
  methods: {
    togglePanelHeight() {
      this.panelMinimized = !this.panelMinimized
    },
    expandTrailGroup(IDobj) {
      IDobj.groupIsCollapsed = !IDobj.groupIsCollapsed
    },
    toggleTrailLayer(pointcloudID, group, turnWholeGroupOn = false) {
      this.$emit('onPointcloudClick', pointcloudID)
    },
    availableTrailButtonCtrl(pointcloudID) {
      const isSelected = this.selectedTrails.some(feature =>
        feature.get('pc_id')?.includes(pointcloudID)
      );

      return isSelected ? 'btn-primary' : 'lidar-off';
    },
    async toggleTrailsGroup(IDobj, event) {
      if (IDobj.groupIsCollapsed) {
        await this.expandTrailGroup(IDobj)
      }
      let group = IDobj.dateCode.toString()

      const groupHasSelectedTrails = this.selectedTrails.some(feature => {
        const name = feature.get('pc_id');
        if (!name) return false;

        return name.split(',').some(part => part.includes(group));
      });

      // If any layer is visible within the group, turn all layers within the group off
      if (groupHasSelectedTrails) {
        // Deselect ALL trails in this group
        const featuresToRemove = this.cart.filter((cartItem) => cartItem.pc_id.includes(group))

        featuresToRemove.forEach(feature => {
          // this.selectedTrailsLayer.getSource().removeFeature(feature);
          this.toggleTrailLayer(feature, IDobj.dateCode, true)
        });
      } else {
        // Make all layers visible
        IDobj.pointcloudIDArr.forEach(pointcloudID => {
          this.toggleTrailLayer(pointcloudID, IDobj.dateCode, true)
        })
      }

      event.target.blur();
    },
    anyPointcloudOfTrailGroupVisible(dateCode) {
      const group = dateCode.toString();

      // Find the pointcloud IDs for this group that currently exist in distinct_trails
      const groupObj = this.distinct_trails.find(g => g.dateCode === group);
      if (!groupObj || !groupObj.pointcloudIDArr?.length) return 'lidar-group-off';

      const groupPcIds = groupObj.pointcloudIDArr.map(pc => pc.pc_id);

      // Check if any selectedTrail exists in this group
      const anySelectedInGroup = this.selectedTrails.some(feature => {
        const name = feature.get('pc_id');
        if (!name) return false;

        // Check if any part of the selected feature matches a pc_id in this group
        return groupPcIds.includes(name);
      });

      return anySelectedInGroup ? 'btn-primary' : 'lidar-group-off';
    }
  },
  mounted() {
    this._setVh = () => {
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
    }
    this._setVh()
    window.addEventListener('resize', this._setVh)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this._setVh)
  },
  watch: {
    zoomLevel: function (newValue) {
      if (newValue < 15) {
        this.panelVisible = false
      } else {
        this.panelVisible = true
      }      
    },
  }
}
</script>